"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var compare_uncertainty_chart_1 = require("./compare-uncertainty.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
require('./compare-uncertainty.component.css');
var CompareUncertaintyComponent = /** @class */ (function (_super) {
    __extends(CompareUncertaintyComponent, _super);
    function CompareUncertaintyComponent($scope, $timeout, terminologyService) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'CompareUncertainty') || this;
        var ctrl = _this;
        _this.orientation = 'vertical';
        _this.chartInverted = true;
        // Initialize terminology with defaults from service
        _this.terminology = terminologyService.getDefaultTerminology();
        // Listen for terminology response
        $scope.$on('terminology:response', function (event, terminology) {
            ctrl.terminology = terminology;
        });
        // Request terminology from parent when component is ready
        $scope.$emit('terminology:request');
        // $scope.$on('command:COMPARE_UNCERTAINTY', (event, args) => ctrl.initComponent(event, args));
        $scope.$on('command:COMPARE_UNCERTAINTY', function (event, args) {
            ctrl.initComponent(event, args);
            ctrl.menu = ctrl.getMenu();
            ctrl.menu.forEach(function (menuItem) {
                if (menuItem['name'] == 'Display') {
                    menuItem['items'].push({
                        'name': 'Rotate Chart',
                        'callback': function () {
                            ctrl.rotateChart();
                        }
                    });
                }
            });
        });
        return _this;
    }
    CompareUncertaintyComponent.prototype.getChartOptions = function (graph, options) {
        this.graph = graph;
        this.options = options;
        options['chartInverted'] = this.chartInverted;
        if (!graph || graph.length == 0) {
            this.tableData = [];
        }
        return compare_uncertainty_chart_1.getChartOptions(graph, options);
    };
    CompareUncertaintyComponent.prototype.rotateChart = function () {
        this.orientation = this.orientation === 'horizontal' ? 'vertical' : 'horizontal';
        this.chartInverted = this.orientation !== 'horizontal';
        this.options['chartInverted'] = this.chartInverted;
        var chartOptions = this.getChartOptions(this.graph, this.options);
        var chartGot = basic_chart_component_1.makeChart(chartOptions);
        basic_chart_component_1.handleResponsiveNess(chartGot);
    };
    CompareUncertaintyComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./compare-uncertainty.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], CompareUncertaintyComponent);
    return CompareUncertaintyComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.CompareUncertaintyComponent = CompareUncertaintyComponent;
CompareUncertaintyComponent.$inject = ['$scope', '$timeout', 'terminologyService'];
angular.module('smartorg.r6.acts.compareUncertainty', []).component('compareUncertainty', CompareUncertaintyComponent);
module.exports = 'smartorg.r6.acts.compareUncertainty';
//# sourceMappingURL=compare-uncertainty.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/compare-uncertainty2/compare-uncertainty.component.js